import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import {Utils} from '../shared/utils';
import {FlashMessagesService} from 'angular2-flash-messages';

import {CadastroComponent} from "../cadastro/cadastro.component";

import { RecuperarSenhaService } from '../recuperar-senha/recuperar-senha.service';
import {AppComponent} from "../app.component";

@Component({
    selector: 'app-nova-senha',
    templateUrl: './nova-senha.component.html',
    styleUrls: ['./nova-senha.component.css'],
    providers:[
      RecuperarSenhaService
    ]
})
export class NovaSenhaComponent extends AppComponent implements OnInit {

    senha: string;
    senha_confirmation: string;
    confSenha: string;
    hash: string;

    ngOnInit() {
      this.route.params.subscribe(params => this.hash = params['hash']);

    }

    onSubmit() {

      let dados_recuperacao = {
        'senha': this.senha,
        'senha_confirmation': this.senha_confirmation,
        'hash': this.hash
      };

      this.recSenhaService.atualizarSenha(dados_recuperacao).subscribe(
        response => {

          let msgColor = 'success';

          if(response.error){
            msgColor = 'danger';
          }

          this.utils.exibirMensagem(response.msg, msgColor);

          if(!response.error){
            this.redirectToLogin();
          }

      }, error => {

        if(error.status == 422){
          var msg = '';

          //console.log(JSON.parse(error._body));

          for(let erro of JSON.parse(error._body).senha ){
            msg += erro+ ' - ';
          }
          error = msg.substr(0, msg.length - 3);
        };

		if (error.status != 500)
			this.utils.exibirMensagem(error, 'danger');
      });
    }



    redirectToLogin(){
      this.router.navigateByUrl('acesso');
    }

}



// WEBPACK FOOTER //
// ./src/app/nova-senha/nova-senha.component.ts